import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sistema_ges_igualdad',
  templateUrl: './sistema_ges_igualdad.component.html',
  styleUrls: ['./sistema_ges_igualdad.component.css']
})
export class Sistema_ges_igualdadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
